import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { isEmpty, range, find } from 'lodash';
import DateSelect from './date-select';

const dateRegex = /^\d{4}-\d{2}-\d{2}$/;

export const validDate = (props, propName, componentName) => {
  if (props[propName] && !dateRegex.test(props[propName])) {
    return new Error(`Invalid date format for prop ${propName} in component ${componentName}`);
  }
};

export default class BirthdayInput extends Component {
  static get propTypes() {
    return {
      className: PropTypes.string,
      birthday: validDate,
      handleUpdate: PropTypes.func.isRequired,
    };
  }

  constructor(props) {
    super(props);
    this.getValue = this.getValue.bind(this);
    this.maxDate = new Date(new Date().getFullYear(), 11, 31);
    this.minDate = new Date(this.maxDate.getFullYear() - 100, 0, 1);

    const dateValues = this.propsToDateValues(props);
    const accepted = !isEmpty(dateValues);
    this.state = {
      year: { value: dateValues.year, accepted },
      month: { value: dateValues.month, accepted },
      day: { value: dateValues.day, accepted }
    };

    this.handleDayChange = this.handleDropdownSelect('day');
    this.handleMonthChange = this.handleDropdownSelect('month');
    this.handleYearChange = this.handleDropdownSelect('year');
  }

  propsToDateValues(props) {
    const value = props.birthday;
    if (!value || !dateRegex.test(value) || new Date(value).toString() === 'Invalid Date') return {};

    return {
      year: Number(value.split('-')[0]),
      month: Number(value.split('-')[1]) - 1,
      day: Number(value.split('-')[2])
    };
  }

  getMonthList() {
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    return range(12)
      .map(m => ({ text: months[m], value: m }));
  }

  getDayList(month, year) {
    year = year || new Date().getFullYear();
    const daysInMonth = new Date(year, month + 1, 0).getDate();

    return range(1, daysInMonth + 1)
      .map(d => ({ text: String(d), value: d }));
  }

  getYearList() {
    const minYear = this.minDate.getFullYear();
    const maxYear = this.maxDate.getFullYear();
    const years = range(maxYear, minYear - 1, -1);

    return years.map(y => ({ text: String(y), value: y }));
  }

  revalidateDay(fieldName, value) {
    const month = fieldName === 'month' ? value : this.state.month.value;
    const year = fieldName === 'year' ? value : this.state.year.value;

    const dayError = find(this.getDayList(month, year), day => day.value === this.state.day.value)
      ? null
      : 'Valid day required';
    return Object.assign({}, this.state.day, { error: dayError, accepted: !dayError });
  }

  handleDropdownSelect(fieldName) {
    return (event, index, value) => {
      if (typeof value !== 'number') return;

      const newState = {
        [fieldName]: {
          ...this.state[fieldName],
          value: value,
          accepted: true,
          error: null
        }
      };

      if (this.state.day.value && (fieldName === 'month' || fieldName === 'year')) {
        Object.assign(newState, { day: this.revalidateDay(fieldName, value, this.state.day) });
      }

      this.setState(newState, this.handleUpdate);
    };
  }

  getValue() {
    const { month, day, year } = this.state;
    const accepted = month.accepted && year.accepted && day.accepted;
    if (!accepted) return null;
    let yearValue;
    let monthValue;
    let dayValue;
    yearValue = year.value || new Date().getFullYear;
    yearValue = yearValue.toString();
    monthValue = (month.value + 1).toString();
    if (monthValue.length === 1) {
      monthValue = `0${monthValue}`;
    }
    dayValue = day.value || 1;
    dayValue = dayValue.toString();
    if (dayValue.length === 1) {
      dayValue = `0${dayValue}`;
    }

    return `${yearValue}-${monthValue}-${dayValue}`;
  }

  handleUpdate() {
    const valid = this.state.month.accepted && this.state.year.accepted && this.state.day.accepted;
    this.props.handleUpdate(valid, this.getValue());
  }

  render() {
    const { month, year, day } = this.state;
    return (
      <div className="birthday-input-container">
        <div className="date-picker-row">
          <div className="date-picker-col">
            <DateSelect
              fieldName="month"
              value={ month.value }
              valueList={ this.getMonthList() }
              onChange={ this.handleMonthChange }
            />
          </div>
          <div className="date-picker-col">
            <DateSelect
              fieldName="day"
              value={ day.value }
              valueList={ this.getDayList(month.value, year.value) }
              onChange={ this.handleDayChange }
            />
          </div>
          <div className="date-picker-col">
            <DateSelect
              fieldName="year"
              value={ year.value }
              valueList={ this.getYearList() }
              onChange={ this.handleYearChange }
            />
          </div>
        </div>
      </div>
    );
  }
}
